import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import NotificationIcon from '@mui/icons-material/NotificationsOutlined';
import type { SxProps } from '@mui/material';
export const Notification = t0 => {
  const $ = _c(5);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    onClick,
    sx
  } = t1;
  let t2;
  if ($[2] !== onClick || $[3] !== sx) {
    t2 = <NotificationIcon sx={sx} onClick={onClick} />;
    $[2] = onClick;
    $[3] = sx;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};